import { render, staticRenderFns } from "./HomeAdministrador.vue?vue&type=template&id=cb9bc286"
import script from "./HomeAdministrador.vue?vue&type=script&lang=js"
export * from "./HomeAdministrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports